import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import FulfillmentTime from 'bento-ordering/menus/components/FulfillmentTime';
import HeadingThree from 'bento-ordering/base/ui_components/HeadingThree';
import { CENTER } from 'bento-ordering/base/constants/alignment';
import { ALIGNMENT_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

/*
  This component packages the Heading and Fulfillment Time Component since they appear together in multiple places
 */

class SelectedFulfillmentOptions extends React.Component {
  static propTypes = {
    requestedFulfillmentIsAsap: PropTypes.bool,
    fulfillmentDate: PropTypes.string,
    fulfillmentTime: PropTypes.string,
    restaurantName: PropTypes.string,
    currentPrepTime: PropTypes.number,
    desktopAlign: ALIGNMENT_PROPTYPES,
    changePickupTime: PropTypes.func,
    dataTestId: PropTypes.string
  };

  render() {
    const {
      restaurantName,
      currentPrepTime,
      fulfillmentTime,
      fulfillmentDate,
      requestedFulfillmentIsAsap,
      desktopAlign,
      changePickupTime,
      dataTestId
    } = this.props;
    return (
      <div>
        <HeadingThree desktopAlign={desktopAlign}>
          Order For Pickup
        </HeadingThree>
        <Box mb={2}>
          <FulfillmentTime
            restaurantName={restaurantName}
            changePickupTime={changePickupTime}
            fulfillmentDate={fulfillmentDate}
            currentPrepTime={currentPrepTime}
            fulfillmentTime={fulfillmentTime}
            requestedFulfillmentIsAsap={requestedFulfillmentIsAsap}
            desktopFullWidth={desktopAlign === CENTER}
            dataTestId={dataTestId}
          />
        </Box>
      </div>
    );
  }
}

export default SelectedFulfillmentOptions;
